import decimal from 'decimal.js';

export const formatCurrency = (val: any) => {
  if (val === '') return '';
  if (val === 0 || val === null) return '£0.00';
  if (val[0] === '£') return val;
  const formated = new Intl.NumberFormat('us-US', {
    currency: 'GBP',
    style: 'currency'
  }).format(val);
  // .replace(/([£|,])/g, '')
  return formated;
};

export const unFormatCurrency = (val: any) => {
  if (!val) return '0';
  if (typeof val === 'number') {
    return `${val}`.replace(/,/g, '').replace('£', '');
  }
  return val.replace(/,/g, '').replace('£', '');
};

export const unFormatCurrencyNumber = (val: any) => {
  if (!val) return 0;
  if (typeof val === 'number') return val;

  const cleanVal = val.replace(/,/g, '').replace('£', '');
  return parseFloat(cleanVal) || 0;
};

export const toFixed = (number: string | number, digits = 2) => {
  const decimalInt = new decimal(Number(number)).toFixed(digits);

  return Number(decimalInt);
};
